// Mock data for Kalshi prediction market replica

export const categories = [
  { id: 'all', name: 'All', href: '/category/all' },
  { id: 'politics', name: 'Politics', href: '/category/politics' },
  { id: 'sports', name: 'Sports', href: '/category/sports' },
  { id: 'culture', name: 'Culture', href: '/category/culture' },
  { id: 'crypto', name: 'Crypto', href: '/category/crypto' },
  { id: 'climate', name: 'Climate', href: '/category/climate' },
  { id: 'economics', name: 'Economics', href: '/category/economics' },
  { id: 'mentions', name: 'Mentions', href: '/category/mentions' },
  { id: 'companies', name: 'Companies', href: '/category/companies' },
  { id: 'financials', name: 'Financials', href: '/category/financials' },
  { id: 'tech', name: 'Tech & Science', href: '/category/tech' },
];

export const trendingTopics = [
  { id: 'for-you', name: 'For you', active: true },
  { id: 'college-championship', name: 'College Championship', active: false },
  { id: 'pro-football', name: 'Pro Football Playoffs', active: false },
  { id: 'jerome-powell', name: 'Jerome Powell', active: false },
  { id: 'scotus', name: 'SCOTUS', active: false },
  { id: 'iran', name: 'Iran', active: false },
  { id: 'greenland', name: 'Greenland', active: false },
  { id: 'venezuela', name: 'Venezuela', active: false },
  { id: 'mayor', name: 'Mayor Mamdani', active: false },
  { id: 'nhl', name: 'NHL', active: false },
];

export const featuredMarket = {
  id: 'college-football-championship',
  title: 'College Football Championship: Miami vs Indiana',
  image: 'https://images.unsplash.com/photo-1508163223045-1880bc36e222?w=400&h=300&fit=crop',
  options: [
    { id: 'mia', name: 'MIA', price: 22, payout: 396, color: 'green' },
    { id: 'ind', name: 'IND', price: 79, payout: 128, color: 'coral' },
  ],
  news: 'Indiana and Miami will meet in the national championship game on Jan. 19 after Indiana advanced with a win over Oregon and Miami secured its spot by defeating Ole Miss.',
  volume: '($token)94,811,582',
  frequency: 'Annually',
  isLive: true,
  liveStatus: '1Q - 3:15',
  team1: { name: 'MIA', logo: 'https://images.unsplash.com/photo-1566577739112-5180d4bf9390?w=100&h=100&fit=crop', score: 0, percentage: 22 },
  team2: { name: 'IND', logo: 'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=100&h=100&fit=crop', score: 0, percentage: 78 },
  chartData: [
    { time: '12:19am', team1: 20, team2: 80 },
    { time: '12:33am', team1: 22, team2: 78 },
    { time: '12:49am', team1: 25, team2: 75 },
    { time: '1:04am', team1: 22, team2: 78 },
    { time: '1:19am', team1: 22, team2: 78 },
  ],
};

export const valueProps = [];

export const markets = [
  {
    id: 1,
    title: 'Next US Presidential Election Winner?',
    image: 'https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?w=300&h=200&fit=crop',
    category: 'politics',
    options: [
      { name: 'J.D. Vance', percentage: 28 },
      { name: 'Gavin Newsom', percentage: 18 },
    ],
    volume: '($token)8,166,028',
  },
  {
    id: 2,
    title: 'Pro Football Champion?',
    image: 'https://images.unsplash.com/photo-1508163223045-1880bc36e222?w=300&h=200&fit=crop',
    category: 'sports',
    options: [
      { name: 'Seattle', percentage: 40 },
      { name: 'Los Angeles R', percentage: 27 },
    ],
    volume: '($token)128,881,769',
    frequency: 'Annually',
  },
  {
    id: 3,
    title: 'Fed decision in January?',
    image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=300&h=200&fit=crop',
    category: 'economics',
    options: [
      { name: 'Fed maintains rate', percentage: 96 },
      { name: 'Cut 25bps', percentage: 4 },
    ],
    volume: '($token)21,183,917',
  },
  {
    id: 4,
    title: 'Pro Basketball Champion?',
    image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=300&h=200&fit=crop',
    category: 'sports',
    options: [
      { name: 'Oklahoma City', percentage: 45 },
      { name: 'Denver', percentage: 13 },
    ],
    volume: '($token)17,068,201',
    frequency: 'Annually',
  },
  {
    id: 5,
    title: 'S&P close price end of 2026?',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=300&h=200&fit=crop',
    category: 'financials',
    options: [
      { name: '7,400 to 7,599.99', percentage: 11 },
      { name: '7,600 to 7,799.99', percentage: 13 },
    ],
    volume: '($token)160,144',
    frequency: 'Annually',
  },
  {
    id: 6,
    title: 'Stanley Cup® Champion?',
    image: 'https://images.unsplash.com/photo-1580692475446-c2fabbbbf835?w=300&h=200&fit=crop',
    category: 'sports',
    options: [
      { name: 'Colorado Avalanche', percentage: 24 },
      { name: 'Tampa Bay Lightning', percentage: 14 },
    ],
    volume: '($token)6,098,049',
    frequency: 'Annually',
  },
  {
    id: 7,
    title: 'Will Trump buy at least part of Greenland?',
    image: 'https://images.unsplash.com/photo-1531168556467-80aace0d0144?w=300&h=200&fit=crop',
    category: 'politics',
    options: [
      { name: 'Before January 20, 2029', percentage: 43 },
      { name: 'Before 2027', percentage: 26 },
    ],
    volume: '($token)3,807,496',
  },
  {
    id: 8,
    title: 'Will Trump invoke the Insurrection Act?',
    image: 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=300&h=200&fit=crop',
    category: 'politics',
    options: [
      { name: 'Before 2027', percentage: 54 },
      { name: 'Before March 2026', percentage: 32 },
    ],
    volume: '($token)464,651',
  },
  {
    id: 9,
    title: 'Will Elon win his case against OpenAI?',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=300&h=200&fit=crop',
    category: 'tech',
    options: [
      { name: 'Yes', percentage: 60, payout: 158 },
      { name: 'No', percentage: 40, payout: 241 },
    ],
    volume: '($token)173,779',
    isBinary: true,
  },
  {
    id: 10,
    title: 'Who will Trump nominate as Fed Chair?',
    image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=300&h=200&fit=crop',
    category: 'economics',
    options: [
      { name: 'Kevin Warsh', percentage: 62 },
      { name: 'Rick Rieder', percentage: 16 },
    ],
    volume: '($token)43,965,673',
  },
  {
    id: 11,
    title: 'Government shutdown on Jan 31, 2026?',
    image: 'https://images.unsplash.com/photo-1569025743873-ea3a9ebe54e0?w=300&h=200&fit=crop',
    category: 'politics',
    options: [
      { name: 'Yes', percentage: 23, payout: 413 },
      { name: 'No', percentage: 77, payout: 125 },
    ],
    volume: '($token)2,982,073',
    isBinary: true,
  },
  {
    id: 12,
    title: 'Oscar nominations for Best Picture?',
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=300&h=200&fit=crop',
    category: 'culture',
    options: [
      { name: 'It Was Just an Accident', percentage: 62 },
      { name: 'F1', percentage: 32 },
    ],
    volume: '($token)7,098,798',
    frequency: 'Annually',
  },
  {
    id: 13,
    title: 'Democratic nominee for President in 2028?',
    image: 'https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?w=300&h=200&fit=crop',
    category: 'politics',
    options: [
      { name: 'Gavin Newsom', percentage: 35 },
      { name: 'Alexandria Ocasio-Cortez', percentage: 10 },
    ],
    volume: '($token)40,656,249',
  },
  {
    id: 14,
    title: 'Republican nominee for President in 2028?',
    image: 'https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?w=300&h=200&fit=crop',
    category: 'politics',
    options: [
      { name: 'J.D. Vance', percentage: 48 },
      { name: 'Marco Rubio', percentage: 17 },
    ],
    volume: '($token)12,144,366',
  },
  {
    id: 15,
    title: 'How high will Bitcoin get in January?',
    image: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=300&h=200&fit=crop',
    category: 'crypto',
    options: [
      { name: 'Above ($token)100,000.00', percentage: 22 },
      { name: 'Above ($token)102,500.00', percentage: 12 },
    ],
    volume: '($token)629,884',
    frequency: 'Monthly',
  },
  {
    id: 16,
    title: 'Grammy Award for Song Of The Year?',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=200&fit=crop',
    category: 'culture',
    options: [
      { name: 'Golden', percentage: 69 },
      { name: 'luther', percentage: 13 },
    ],
    volume: '($token)1,609,014',
    frequency: 'Annually',
  },
];

export const liveGames = [
  {
    id: 1,
    title: 'Phoenix at Brooklyn',
    subtitle: 'Pro Basketball (M)',
    image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=300&h=200&fit=crop',
    team1: { name: 'PHX', logo: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=50&h=50&fit=crop', percentage: 91 },
    team2: { name: 'BKN', logo: 'https://images.unsplash.com/photo-1574623452334-1e0ac2b3ccb4?w=50&h=50&fit=crop', percentage: 11 },
    status: '2ND - 10:47',
    score: { team1: 60, team2: 45 },
    volume: '($token)850,707',
  },
  {
    id: 2,
    title: 'What will the announcers say during the College Football Playoff National Championship?',
    image: 'https://images.unsplash.com/photo-1508163223045-1880bc36e222?w=300&h=200&fit=crop',
    options: [
      { name: 'Wild', percentage: 50 },
      { name: 'Superbowl / Super Bowl', percentage: 48 },
    ],
    startTime: 'Starting soon · Jan 19, 7:30pm EST',
    volume: '($token)818,664',
  },
];
